import { render, staticRenderFns } from "./SoldProducts.vue?vue&type=template&id=10df8919&scoped=true&"
import script from "./SoldProducts.vue?vue&type=script&lang=js&"
export * from "./SoldProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df8919",
  null
  
)

export default component.exports